import {GoodDetailsCardRec} from "./GoodDetailsCard.ts";

export interface GoodDetailsRec {
    shortDescription: string;
    image:string;
    description: string;
    goodDate: string;
    score: number;
    companyLogo: string;
    companyName: string;
    companyInformation: string;
}

export class GoodDetailsBuilder {
    private rec: GoodDetailsRec = {
        shortDescription: '',
        image: '',
        description: '',
        goodDate: '',
        score: 0,
        companyLogo: '',
        companyName: '',
        companyInformation: '',
    };

    private constructor() {}

    static rec(): GoodDetailsBuilder {
        return new GoodDetailsBuilder();
    }

    shortDescription(value: string): this {
        this.rec.shortDescription = value;
        return this;
    }

    image(value: string): this {
        this.rec.image = value;
        return this;
    }

    description(value: string): this {
        this.rec.description = value;
        return this;
    }

    goodDate(value: string): this {
        this.rec.goodDate = value;
        return this;
    }

    score(value: number): this {
        this.rec.score = value;
        return this;
    }

    companyLogo(value: string): this {
        this.rec.companyLogo = value;
        return this;
    }

    companyName(value: string): this {
        this.rec.companyName = value;
        return this;
    }

    companyInformation(value: string): this {
        this.rec.companyInformation = value;
        return this;
    }

    fromGoodDetailsCardRec(rec: GoodDetailsCardRec): this {
        this.shortDescription(rec.goodTitle);
        this.image(rec.goodImg);
        this.description(rec.goodDescription);
        this.goodDate(rec.goodDate);
        this.score(rec.goodPoints);
        this.companyLogo(rec.logoImg);
        this.companyName(rec.companyName);
        this.companyInformation(rec.companyDescription);
        return this;
    }
    
    build(): GoodDetailsRec {
        return this.rec as GoodDetailsRec;
    }
}
